import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { i18nService } from "../../i18n";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Menu from "./Menu";
import Toolbar from "./Toolbar";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { globalServices } from "../../Services";
import AIChatModal from "./AIChatModal/AIChatModal";

import "./Layout.css";

export default function Layout(props) {
  const history = useHistory();

  const { isActiveMenu, updatedResource, selectedLanguageId } =
    useContext(GlobalContext);

  const [isLoading, setIsLoading] = useState(true);

  const [translations, setTranslations] = React.useState();
  const [translationsCache, setTranslationsCache] = React.useState([]);
  const [i18nConfig, setI18nConfig] = React.useState(null);

  const setCSSVariable = (varName, varValue) => {
    document.documentElement.style.setProperty(varName, varValue);
  };

  useEffect(() => {
    setCSSVariable("--primary-color", window.REACT_APP_COLOR);
    setCSSVariable("--fiscal-alert", window.REACT_APP_ALERT_COLOR);

    const data = translationsCache.find((tc) => tc.lang == selectedLanguageId);
    if (!data) {
      globalServices
        .getResourcesByLanguageId(selectedLanguageId)
        .then((data) => {
          setTranslationsCache([
            ...translationsCache,
            { lang: selectedLanguageId, translations: data.data },
          ]);
          setTranslations(data.data);
        })
        .catch(() => history.push("/Error"));
    } else {
      setTranslations(data.translations);
    }
  }, [selectedLanguageId]);

  useEffect(() => {
    const data = translationsCache.find(
      (tc) => tc.lang == updatedResource.languageId,
    );

    if (data) {
      var updatedTranslations = {
        ...data.translations,
        [updatedResource.key]: updatedResource.value,
      };

      setTranslationsCache([
        ...translationsCache,
        { lang: selectedLanguageId, translations: updatedTranslations },
      ]);

      if (selectedLanguageId == updatedResource.languageId) {
        setTranslations(updatedTranslations);
      }
    }
  }, [updatedResource]);
  useEffect(() => {
    if (translations) {
      i18nService(translations).then((data) => {
        setI18nConfig(data);
        setIsLoading(false);
      });
    }
  }, [translations]);

  return (
    <>
      {!isLoading && (
        <I18nextProvider i18n={i18nConfig}>
          {props.publicRoute ? (
            <div>{props.children}</div>
          ) : (
            <>
              <Navbar className="root-layout__navbar" />
              <div className="wrapper root-layout__wrapper">
                <Menu className={"root-layout__menu"} />
                <div
                  className="container-fluid p-0 root-layout__content-wrap"
                  id={isActiveMenu ? "content-wrap" : "content-wrap-full"}
                >
                  <Toolbar
                    parentName={props.parentName}
                    parentRoute={props.parentRoute}
                    currentName={props.currentName}
                    showHome={props.showHome}
                    show={props.show}
                  />
                  <div className="container-fluid">
                    {props.children}
                    <div className="floating-items">
                      {/* <ToastMessage
                        show={showUnfBilToast}
                        message={[
                          "UnfiscalizedBillsToastMessage",
                          { number: unfiscalizedBillCount },
                        ]}
                      /> */}
                      {window.REACT_APP_AICHAT && <AIChatModal />}
                    </div>
                  </div>
                </div>
              </div>
              <Footer className={"root-layout__footer"} />
            </>
          )}
        </I18nextProvider>
      )}
    </>
  );
}
